exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  border-radius: 0;\n  margin: 0;\n  padding-top: 15px;\n  padding-bottom: 15px; }\n\ndiv.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n@media only screen and (max-width: 991px) {\n  .footerContent {\n    padding: 15px; } }\n\n.iframeWrapper {\n  text-align: center; }\n\niframe {\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = main